module.exports = new __parcel__URL__("check-circle.5331953b.svg").toString();